<template>
  <div v-if="observer">
    <div
      v-for="item in effectiveItems"
      :key="item.index"
      :class="{ 'sf-dim-el': currentIndex !== item.index }"
      data-testid="workflow-review-item"
    >
      <workflow-review-item
        v-bind="item"
        :focused="currentIndex === item.index"
        :observer="observer"
        :should-focus="item.index === nextItemIndexToFocus"
        :should-link-inputs-to-remarks="
          contextId === item.contextId &&
          fetchingCommunicationsStatus === COMPLETED
        "
        :get-scrollable-ref="getScrollableRef"
        :error="item.error"
        :diff-limit-reached="item.diffLimitReached"
        :workflow-review-status-data="reviewItemStatus[getReviewItemKey(item)]"
      />
    </div>

    <div v-if="items.length !== total" class="sf-level sf-level-center">
      <div class="sf-spinner sf-spinner-primary sf-spinner-l" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import WorkflowReviewItem from './workflow-review-item'
import { requestStatus } from '@app/application/constants/comms'
import { getReviewItemKey } from '@app/application/workflows/screens/workflow-review/utils'

import { useWorkflowOverview } from '@app/application/workflow-overview-navigation/store/overview.ts'
import { useWorkflowReviewItemStatus } from '../store/pinia/workflow-review-item-status'

export default {
  components: {
    WorkflowReviewItem,
  },
  props: {
    contextId: {
      type: Number,
    },
    currentIndex: {
      type: Number,
    },
    fetchingCommunicationsStatus: {
      type: String,
    },
    getScrollableRef: {
      type: Function,
    },
    items: {
      type: Array,
    },
    nextItemIndexToFocus: {
      type: Number,
    },
    observer: {
      type: IntersectionObserver,
    },
    total: {
      type: Number,
    },
  },
  setup() {
    return {
      getReviewItemKey,
    }
  },
  computed: {
    ...mapState(useWorkflowReviewItemStatus, ['reviewItemStatus']),
    ...mapState(useWorkflowOverview, [
      'filteredElementsById',
      'hasAnyFilterApplied',
    ]),
    effectiveItems() {
      if (!this.hasAnyFilterApplied) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return this.items.map(({ placeholder, ...rest }) => {
          return { ...rest }
        })
      }

      return this.items.reduce((acc, item) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { placeholder, ...rest } = item
        const filteredItem = this.filteredElementsById[item.itemClass][item.id]

        if (filteredItem) {
          acc.push({ ...rest })
        }

        return acc
      }, [])
    },
  },
  created() {
    this.COMPLETED = requestStatus.COMPLETED
  },
  beforeUnmount() {
    this.observer.disconnect()
  },
}
</script>
